import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ElementLoaderService {
  appendStylesheet(document: Document, url: string, cb: () => void = () => {}) : Element {
    const stylesheet = document.createElement("link");
    stylesheet.href = url;
    stylesheet.rel = 'stylesheet';
    stylesheet.type = 'text/css';
    stylesheet.onload = () => { cb(); };
    document.getElementsByTagName("head")[0].appendChild(stylesheet);
    return stylesheet;
  }
  
  appendManifest(document: Document, url: string, cb: () => void = () => {}) : Element {
    const stylesheet = document.createElement("link");
    stylesheet.href = url;
    stylesheet.rel = 'manifest';
    stylesheet.onload = () => { cb(); };
    document.getElementsByTagName("head")[0].appendChild(stylesheet);
    return stylesheet;
  }
}
